module.exports = __webpack_public_path__ + "img/banner.d7fc6c43.png";